/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionResponse } from '../models/ActionResponse';
import type { User } from '../models/User';
import type { UserResponse } from '../models/UserResponse';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * @returns boolean
     * @throws ApiError
     */
    public static async userIsAuthenticated(): Promise<boolean> {
        const result = await __request({
            method: 'GET',
            path: `/api/user/authenticated`,
        });
        return result.body;
    }

    /**
     * @returns UserResponse
     * @throws ApiError
     */
    public static async userGetUser(): Promise<UserResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/user`,
        });
        return result.body;
    }

    /**
     * @returns boolean
     * @throws ApiError
     */
    public static async userIsInvited(): Promise<boolean> {
        const result = await __request({
            method: 'GET',
            path: `/api/user/isInvited`,
        });
        return result.body;
    }

    /**
     * @returns boolean
     * @throws ApiError
     */
    public static async userUserExists(): Promise<boolean> {
        const result = await __request({
            method: 'GET',
            path: `/api/user/exists`,
        });
        return result.body;
    }

    /**
     * @returns ActionResponse
     * @throws ApiError
     */
    public static async userCreateUser({
        user,
    }: {
        user: User,
    }): Promise<ActionResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/user/create`,
            body: user,
        });
        return result.body;
    }

}